import { render, staticRenderFns } from "./ClientQuotation.vue?vue&type=template&id=9c6b4592"
import script from "./ClientQuotation.vue?vue&type=script&lang=js"
export * from "./ClientQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports